/**
 * Safely quote a URL for CSS url(...).
 * Unquoted urls break when the path contains parentheses, e.g. Image (1).jpeg.
 */
export function cssUrl(url) {
  if (!url) return null;

  const escaped = String(url)
    .replace(/\\/g, '\\\\')
    .replace(/"/g, '\\"');

  return `url("${escaped}")`;
}

/**
 * Build a CSS background value that safely supports special characters in URLs.
 */
export function cssBackgroundImage(url, fallback = 'var(--color-studio)') {
  const value = cssUrl(url);
  if (!value) {
    return fallback;
  }

  return `${fallback} ${value} center / cover no-repeat`;
}

/** Prefer default colour image, then thumbnail / first gallery image, then legacy image_url. */
export function getProductImageUrl(product) {
  if (!product) return null;

  const images = [...(product.product_images || product.images || [])].sort(
    (a, b) => (a.sort_order || 0) - (b.sort_order || 0)
  );
  const variants = product.product_variants || product.variants || [];
  const defaultVariant =
    variants.find(variant => variant.is_default) || variants[0] || null;

  if (defaultVariant) {
    const defaultImages = images.filter(image => image.variant_id === defaultVariant.id);
    const defaultThumb =
      defaultImages.find(image => image.is_thumbnail) || defaultImages[0];
    if (defaultThumb?.image_url) return defaultThumb.image_url;
  }

  const thumbnail = images.find(image => image.is_thumbnail) || images[0];
  return thumbnail?.image_url || product.image_url || null;
}

/** Second gallery image for product-card hover, if one exists. */
export function getProductHoverImageUrl(product) {
  if (!product) return null;

  const primary = getProductImageUrl(product);
  const images = [...(product.product_images || product.images || [])].sort(
    (a, b) => (a.sort_order || 0) - (b.sort_order || 0)
  );
  const hover = images.find(image => image?.image_url && image.image_url !== primary);
  return hover?.image_url || null;
}
